import environment from '../environments/index';

const parseDays = (value: number | undefined, fallback: number): number => {
  if (typeof value === 'number' && Number.isFinite(value) && value > 0) {
    return Math.floor(value);
  }
  return fallback;
};

export const getFreeTrialDays = (): number =>
  parseDays(environment.subscription?.freeTrialDays, 30);

export const getFreeTrialEarlyAdopterDays = (): number =>
  parseDays(environment.subscription?.freeTrialEarlyAdopterDays, 90);

export const formatFreeTrialDaysLabel = (days: number): string =>
  `${days} ${days === 1 ? 'día' : 'días'}`;

export const formatFreeTrialDaysActivated = (days: number): string =>
  `${formatFreeTrialDaysLabel(days)} activados`;

export const formatFreeTrialGratisPor = (days: number): string =>
  `Gratis por ${formatFreeTrialDaysLabel(days)}`;

export const formatPruebaGratisPorUpper = (days: number): string =>
  `PRUEBA GRATIS POR ${days} ${days === 1 ? 'DÍA' : 'DÍAS'}`;
